<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>
    <v-toolbar
      app
      color="primary"
      class="elevation-1"
    >
      <v-toolbar-side-icon @click.stop="drawer = !drawer" class="white--text"></v-toolbar-side-icon>
      <v-spacer></v-spacer>
      <v-toolbar-title class="white--text">Transaction List</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-content>
      <v-container grid-list-lg>
        <v-layout fluid wrap>
          <!--
          <v-flex xs4>
            <v-menu
              ref="menu1"
              :close-on-content-click="false"
              v-model="dtPicker1"
              :nudge-right="40"
              :return-value.sync="date1"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="date1"
                label="Date from"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="date1" no-title scrollable @input="$refs.menu1.save(date1)"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs4>
            <v-menu
              ref="menu2"
              :close-on-content-click="false"
              v-model="dtPicker2"
              :nudge-right="40"
              :return-value.sync="date2"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="date2"
                label="Date to"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="date2" no-title scrollable @input="$refs.menu2.save(date2)"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs4>
            <v-btn block
            >
              Filter
            </v-btn>
          </v-flex>
          -->
          <v-flex xs12 class="text-xs-center">
            <v-data-table
              :items="transactions"
              hide-actions
              class="elevation-1"
            >
              <template slot="headers">
                <tr>
                  <th class="text-xs-center subheading font-weight-bold">
                    Date
                  </th>
                  <th class="text-xs-left subheading font-weight-bold">
                    Details
                  </th>
                  <th class="text-xs-right hidden-xs-only subheading font-weight-bold">
                    Debit
                  </th>
                  <th class="text-xs-right hidden-xs-only subheading font-weight-bold">
                    Credit
                  </th>
                  <th class="text-xs-right hidden-xs-only subheading font-weight-bold">
                    Balance
                  </th>
                  <th class="text-xs-right hidden-sm-and-up subheading font-weight-bold">
                    Amount
                  </th>
                </tr>
              </template>
              <template slot="items" slot-scope="props">
                <tr
                :class="(props.index % 2 === 0 ? 'row1' : 'row2')"
                >
                  <td class="text-xs-center">{{ props.item.createdDateTime | formatDate('DD MMMM YYYY HH:mm', profile.gmtTimezone) }}</td>
                  <td class="text-xs-left">
                    <router-link v-if="props.item.url" :to="props.item.url" class="black--text">{{ props.item.details }}</router-link>
                    <span v-else>{{ props.item.details }}</span>
                    <v-btn
                      v-if="props.item.transactionId === 'TRX-SUMMARY'"
                      small
                      outline
                      color="primary"
                      @click="loadFullTransactions"
                      class="ml-3"
                    >
                      View
                    </v-btn>
                  </td>
                  <td class="text-xs-right hidden-xs-only">
                    <div>{{ (props.item.type === 'debit' ? def.currency.sign + formatPrice(props.item.amountInBase) : '') }}</div>
                    <div v-if="props.item.type === 'debit' && props.item.storeCurrencyCode && props.item.storeCurrencyCode !== def.currency.currencyCode" class="caption grey--text">{{ props.item.storeCurrencySign + formatPrice(props.item.amountInBase / props.item.exchangeRateFromStoreCurrencyToBase, props.item.storeCurrencyDecimals, props.item.storeCurrencyDecimalSign) }}</div>
                  </td>
                  <td class="text-xs-right hidden-xs-only">
                    <div>{{ (props.item.type === 'credit' ? def.currency.sign + formatPrice(props.item.amountInBase) : '') }}</div>
                    <div v-if="props.item.type === 'credit' && props.item.storeCurrencyCode && props.item.storeCurrencyCode !== def.currency.currencyCode" class="caption grey--text">{{ props.item.storeCurrencySign + formatPrice(props.item.amountInBase / props.item.exchangeRateFromStoreCurrencyToBase, props.item.storeCurrencyDecimals, props.item.storeCurrencyDecimalSign) }}</div>
                  </td>
                  <td class="text-xs-right hidden-xs-only">{{ def.currency.sign }}{{ formatPrice(props.item.balance) }}</td>
                  <td class="text-xs-right hidden-sm-and-up font-weight-bold">{{ def.currency.sign + (props.item.type === 'debit' ? '-' : '') + formatPrice(props.item.amountInBase) }}</td>
                </tr>
              </template>
              <template slot="footer">
                <td colspan="2" class="hidden-xs-only"></td>
                <td class="text-xs-right hidden-xs-only">
                  {{ def.currency.sign }}{{ formatPrice(totalDebit) }}
                </td>
                <td class="text-xs-right hidden-xs-only">
                  {{ def.currency.sign }}{{ formatPrice(totalCredit) }}
                </td>
                <td class="text-xs-right title font-weight-bold hidden-xs-only">
                  <strong>{{ def.currency.sign }}{{ formatPrice(totalBalance) }}</strong>
                </td>
                <td colspan="6" class="text-xs-right title font-weight-bold hidden-sm-and-up">
                  <strong>{{ def.currency.sign }}{{ formatPrice(totalBalance) }}</strong>
                </td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>
      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="220"
      >
        <loading></loading>
      </v-dialog>
    </v-content>
  </div>
</template>

<style scoped>
form {
  width: 100%;
}
</style>

<script>
import SideDrawer from '@/components/SideDrawer.vue'
import Loading from '@/components/Loading.vue'
import router from '../router'
import axios from 'axios'

export default {
  components: {
    SideDrawer,
    Loading
  },
  data () {
    return {
      profile: this.$store.getters.getProfile,
      def: this.$store.getters.getDef,
      drawer: false,
      loading: false,
      date1: null,
      date2: null,
      dtPicker1: false,
      dtPicker2: false,
      transactions: [],
      totalDebit: 0,
      totalCredit: 0,
      totalBalance: 0,
      showFullList: false
    }
  },

  mounted () {
    this.openDrawerForDesktop()
    this.getTransactions()
    this.disableBottomDetector()
  },

  methods: {
    getTransactions: function (fullList = false) {
      var _this = this
      var promise = new Promise(function (resolve, reject) {
        _this.loading = true
        var url = process.env.VUE_APP_API_ROOT + '/v1/store/transactions'
        if (fullList) {
          url += '?full-list=1'
        }
        axios.get(url)
          .then(resp => {
            _this.loading = false
            console.log(resp.data)
            if (resp.data.status === 'success') {
              var balance = 0
              for (var i = 0; i < resp.data.data.length; i++) {
                // inverse the transaction type first
                if (resp.data.data[i].type === 'debit') {
                  resp.data.data[i].type = 'credit'
                } else {
                  resp.data.data[i].type = 'debit'
                }

                if (resp.data.data[i].type === 'debit') {
                  balance = balance - resp.data.data[i].amountInBase
                  _this.totalDebit = _this.totalDebit + resp.data.data[i].amountInBase
                } else {
                  balance = balance + resp.data.data[i].amountInBase
                  _this.totalCredit = _this.totalCredit + resp.data.data[i].amountInBase
                }
                resp.data.data[i].balance = balance
                resp.data.data[i].url = ''
                if (resp.data.data[i].forSalesOrderNo.length > 0) {
                  resp.data.data[i].url = '/order/' + resp.data.data[i].forSalesOrderNo
                } else if (resp.data.data[i].forPaymentId.length > 0) {
                  resp.data.data[i].url = '/payment/' + resp.data.data[i].forPaymentId
                }
              }
              _this.transactions = resp.data.data
              _this.totalBalance = resp.data.total * -1 // inverse the amount
            } else {
              console.log('unable to load transactions: ' + resp.data.message)
            }
            resolve()
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
                reject(error.response.status)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
                reject(error.response.status)
              }
              _this.loading = false
            }
          })
      })
      return promise
    },

    loadFullTransactions: function () {
      this.showFullList = true
      this.totalDebit = 0
      this.totalCredit = 0
      this.totalBalance = 0
      this.transactions = []
      this.getTransactions(true)
    }
  }
}
</script>
